import PropTypes from 'prop-types';

import Presenter from 'utils/PropTypesPresenter';

export default new Presenter({
  name: PropTypes.string,
  value: PropTypes.string,
  displayName: PropTypes.string,
});
